module.exports = __webpack_public_path__ + "img/jiaot6.bdc71e8a.png";